
// import {extent as d3_extent} from 'd3-array'
import {select as d3_select} from 'd3-selection'
// import drawGradientRect from '../utils/drawGradientRect'

function MultiDataPickerBehavior ($root,viz,config={}) {
  const mode = 'buttons' //'select' //El bueno sera "slider", no?
  if(!viz.data) return

  let dataPicker = d3_select($root).selectAll('.data-picker').data(config.showPicker?[null]:[])
  dataPicker.exit().remove()
  let dataPickerEnter= dataPicker.enter().append('div').attr('class','data-picker')
  dataPicker = dataPicker.merge(dataPickerEnter)
  let pages = viz.data.isMulti?viz.data.data.map((d,i)=>d.id):[0]

  if(mode==='select'){
    let select = dataPicker.select('select').merge(dataPickerEnter.append('select'))
    let options = select.selectAll('option').data(pages,(d)=>d)
    options.exit().remove()
    options.enter().append('option').attr('value',(d)=>d).html((d)=>d)
    select.on('change',(e)=>{
      viz.config = {...viz.config, currentPage: +e.target.value}
    })
    
    if(config.showPicker) dataPicker.select('select').node().value = viz.config.currentPage
  } else {
    dataPicker.style('display','flex')
    let buttons = dataPicker.selectAll('.btn').data(pages,(d)=>d)
    let buttonsEnter = buttons.enter().append('div').attr('class','btn')
    buttonsEnter.html((d)=>d)
    buttonsEnter.on('click',(e,d)=>{
      viz.config = {...viz.config, currentPage: d}
    })
    if(config.showPicker) {
      dataPicker.selectAll('.btn').style('background',(d)=>{
        return viz.config.currentPage === d ?'#f00':'#ddd'
      })
    }
    buttons.exit().remove()
  }
  
}
MultiDataPickerBehavior.defaultConfig = {
  index: 301,
  showPicker: {
    type: Boolean,
    default: false,
    exposed: true,
  },
 
}
MultiDataPickerBehavior.configName = 'MultiDataPickerBehavior'

export default MultiDataPickerBehavior
